import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import moment from 'moment';
import { MenuItem } from 'primeng-lts/api';
import { Slider } from 'primeng-lts/slider';
import { CalendarModule } from 'primeng-lts/calendar';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { InputNumberModule } from 'primeng-lts/inputnumber';

import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { WaitTimeService } from 'src/app/events/services/wait-time.service';
import {
  CipiaMultimediaParam,
  IntervalTime,
  MultimediaItem,
  SourceCipiaMultimedia,
  TypeCipiaMultimedia,
  VideoOnDemandTime,
} from 'src/app/multiview/models/interfaces';
import { MultimediaService } from 'src/app/multiview/services/multimedia.service';
import { PermissionService } from 'src/app/permiss/permission.service';
import { MomentService } from 'src/app/vehicles/services/moment.service';
import { param } from 'jquery';
import { MapAsideService } from 'src/app/panel/components/map-aside/service/map-aside.service';
import { Subscription } from 'rxjs';
import { EventService } from 'src/app/events/services/event.service';

@Component({
  selector: 'app-slider-multimedia',
  templateUrl: './slider-multimedia.component.html',
  styleUrls: ['./slider-multimedia.component.scss'],
  providers: [Slider, CalendarModule, InputNumberModule],
})
export class SliderMultimediaComponent
  implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  @Input() event!: any;
  @Input() rowSelected!: HTMLElement;
  @Input() driver: string = '';
  @Input() showFooter: boolean = false;
  @Input() showMultimediaFirst: boolean = true;
  @Input() showMultimedias: boolean = false;
  @Input() hasMultimedia: boolean = false;
  @Input() showTitle: boolean = true;
  @Input() isPopup: boolean = false;

  sliderContent!: HTMLElement | null;

  loading = false;
  error = false;

  multimediaCipiaItems: any[] = []

  menuMultimedia: MenuItem[] = [];

  isMaximized = false;

  @ViewChild('multimedia_wrapper') multimediaWrapper!: ElementRef;
  @ViewChild('_slider') sliderComponent!: Slider;

  icons_available = [
    'alcoholemia',
    'anticolision-frontal',
    'bloqueo-vision-mobileye',
    'colision-peatones',
    'zona-riesgo-colision-peatones',
    'desvio-de-carril-derecha',
    'desvio-de-carril-izquierda',
    'exceso-velocidad',
    'fatiga-extrema',
    'no-rostro',
  ];

  // -------- cipia multimedia

  displayMultimedia = false;
  //multimedias: MultimediaItem[] = [];
  get activeIndex(): number {
    return this._activeIndex;
  }

  set activeIndex(newValue) {
    if (
      this.getMultimediaItems() &&
      1 <= newValue &&
      newValue <= this.getMultimediaItems().length
    ) {
      this._activeIndex = newValue;
    }
  }

  _activeIndex: number = 1;

  // -------- end  cipia multimedia
  private destroy$ = new Subject<void>();

  // ---- getvideo dialog
  showGetVideoDialog = false;
  showRecordVideoDialog = false;
  rangeValues: number[] = [20, 80];

  // detalles especificos (obtener video)
  permissionGetVideoDetail: boolean = false;
  videoRequestModes = [
    { label: 'Simple', value: 'simple' },
    { label: 'Detallado', value: 'detail' },
  ];
  videoRequestModeSimple: string = 'simple';

  maximosDias: number = 7;
  maxDate: Date = new Date();
  maxTime?: Date = new Date();

  selectedTime: Date = new Date(); // hora
  selectedDate: Date = new Date(); // dia defecto

  dayOptions: { label: string; value: Date }[] = [];
  selectedDay: { label: string; value: Date } | null = null;
  selectedDayCalendar: Date | null = new Date();

  duration: number = 40;

  public showMultimediaControls: boolean = false;
  private auxShowMultimediaControls: boolean = false;
  private mouseTimer: any = null;

  private multimediaSubscription?: Subscription;

  onShowMultimediaControls() {
    this.showMultimediaControls = true;
    this.auxShowMultimediaControls = true;
  }

  onHideMultimediaControls() {
    this.showMultimediaControls = false;
    this.auxShowMultimediaControls = false;
  }

  onMouseMove() {
    if (this.auxShowMultimediaControls) {
      this.showMultimediaControls = true;
    }
    if (this.mouseTimer) {
      clearTimeout(this.mouseTimer);
    }
    this.mouseTimer = setTimeout(() => {
      this.showMultimediaControls = false;
    }, 2000);
  }


  public onInputSelectedTime(event: any) {
    console.log("select time,", event)
  }

  public getVideoSpecificRange() {
    console.log("hoal")
    const startDate = this.getStartDateSpecific();
    const endDate = new Date(startDate.getTime() + this.duration * 1000); // Duración en milisegundos

    return {
      startDate: this.formatDate(startDate),
      endDate: this.formatDate(endDate),
    };
  }

  videoRange: { startDate: string; endDate: string } | null = null;
  // Llama a esto cada vez que cambie la duración o la fecha de inicio
  updateVideoRange() {
    const startDate = this.getStartDateSpecific();
    const endDate = new Date(startDate.getTime() + this.duration * 1000);

    this.videoRange = {
      startDate: this.formatDate(startDate),
      endDate: this.formatDate(endDate),
    };
  }


  public getFormattedDateInLocal(): string {
    const selectedDate = this.selectedDayCalendar || this.selectedDate;
    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
    const day = String(selectedDate.getDate()).padStart(2, '0');

    const hour = String(this.selectedTime.getHours()).padStart(2, '0');
    const minute = String(this.selectedTime.getMinutes()).padStart(2, '0');
    const second = this.selectedDayCalendar
      ? String(this.selectedTime.getSeconds()).padStart(2, '0')
      : '00';

    return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
  }

  public getFormattedDateInUTC(): string {
    const selectedDate = this.selectedDayCalendar || this.selectedDate;
    const year = selectedDate.getUTCFullYear();
    const month = String(selectedDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(selectedDate.getUTCDate()).padStart(2, '0');

    const hour = String(this.selectedTime.getHours()).padStart(2, '0');
    const minute = String(this.selectedTime.getMinutes()).padStart(2, '0');
    const second = this.selectedDayCalendar
      ? String(this.selectedTime.getSeconds()).padStart(2, '0')
      : '00';

    return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
  }
  private getStartDateSpecific(): Date {
    const baseDate = this.selectedDayCalendar || this.selectedDate;
    baseDate.setHours(
      this.selectedTime.getHours(),
      this.selectedTime.getMinutes(),
      this.selectedTime.getSeconds(),
      0
    );
    return baseDate;
  }
  private formatDate(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  public isTimeOutOfRange: boolean = false;

  isTimeWithinRange() {
    if (!this.maxTime) {
      this.isTimeOutOfRange = true;
      return this.isTimeOutOfRange;
    }
    // Combina selectedDay (fecha) y selectedTime (hora)
    const combinedDate = this.selectedDayCalendar || this.selectedDate;
    combinedDate.setHours(this.selectedTime.getHours());
    combinedDate.setMinutes(this.selectedTime.getMinutes());
    combinedDate.setSeconds(this.selectedTime.getSeconds());
    this.isTimeOutOfRange = !(combinedDate <= this.maxTime);
    return this.isTimeOutOfRange;
  }
  generateDays() {
    let currentDate = new Date(this.maxDate);
    for (let i = 0; i < this.maximosDias; i++) {
      const day = new Date(currentDate);
      day.setDate(currentDate.getDate() - i); // Retrocedemos un día
      this.dayOptions.push({
        label: day.toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }), // Formato: día de mes de año
        value: day,
      });
    }
    this.selectedDay = this.dayOptions[0];
  }
  getStartDate(): Date {
    const startTime = new Date(this.selectedDate);
    const hour = this.selectedTime.getHours();
    const minute = this.selectedTime.getMinutes();

    startTime.setHours(hour, minute, 0, 0);
    return startTime;
  }
  getEndDate(): Date {
    const startTime = this.getStartDate();
    const endTime = new Date(startTime);

    endTime.setSeconds(startTime.getSeconds() + this.duration);

    return endTime;
  }

  public getMultimediaCipiaItems(uuid: string) {
    console.log("get multimedia cipia", this.multimediaService.getMultimediaListByUuid(uuid))
    return this.multimediaService.getMultimediaListByUuid(uuid);
  }

  getFormattedStartDate(): string {
    return this.getStartDate().toLocaleString();
  }
  getFormattedEndDate(): string {
    return this.getEndDate().toLocaleString();
  }
  getMultimediaItems() {
    return this.multimediaService.getMultimediaListByUuid(
      this.event.uuid_event
    );
  }

  updateSelectedTime(time: string | number) {
    this.selectedTime = this.getCurrentTime(time);
  }

  getCurrentTime(time: string | number): Date {
    const currentDate = new Date(time);
    return currentDate;
  }
  recordTime: number = 30;
  min_range = 0;
  max_range = 0;
  gradientColor = '#c2c2c250';
  gradientMargin = '1rem';

  mediaCipiaOptions: {
    label: string;
    value: SourceCipiaMultimedia;
  }[];
  mediaStoreCipiaOptions: {
    label: string;
    value: SourceCipiaMultimedia;
    disabled?: boolean;
  }[];
  mediaCipiaValue: SourceCipiaMultimedia = 'CABIN';
  mediaStoreCipiaValue: SourceCipiaMultimedia = 'CABIN';

  constructor(
    public multimediaService: MultimediaService,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    public waitTimeService: WaitTimeService,
    private momentService: MomentService,
    private permissionService: PermissionService,
    private mapAsideService: MapAsideService,
    private eventService: EventService
  ) {
    this.mediaCipiaOptions = [
      { label: 'Conductor', value: 'CABIN' },
      { label: 'Camino', value: 'ROAD' },
      { label: 'Ambos', value: 'BOTH' },
    ];
    this.mediaStoreCipiaOptions = [
      { label: 'Conductor', value: 'CABIN' },
      { label: 'Camino', value: 'ROAD' },
      // { label: 'Ambos', value: 'BOTH', disabled: true },
    ];

    this.mediaCipiaValue = this.mediaCipiaOptions[0].value;
    this.mediaStoreCipiaValue = this.mediaStoreCipiaOptions[0].value;
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.cdRef.detectChanges();
  }
  private initializeMultimediaOptions() {
    const options: { [key in SourceCipiaMultimedia]: string } = {
      CABIN: 'Conductor',
      ROAD: 'Camino',
      BOTH: 'Ambos',
    };

    const addOption = (value: SourceCipiaMultimedia, label: string): void => {
      const option = { label, value };
      this.mediaStoreCipiaOptions.push(option);
      this.mediaCipiaOptions.push(option);
    };

    if (this.hasMultimediaCabin()) {
      addOption('CABIN', options.CABIN);
    }

    if (this.hasMultimediaRoad()) {
      addOption('ROAD', options.ROAD);
    }

    if (this.mediaCipiaOptions.length >= 2) {
      this.mediaCipiaOptions.push({
        label: options.BOTH,
        value: 'BOTH',
      });
    }
    if (this.mediaCipiaOptions.length == 0) {
      addOption('CABIN', options.CABIN);
    }

    this.mediaCipiaValue = this.mediaCipiaOptions[0]?.value;
    this.mediaStoreCipiaValue = this.mediaStoreCipiaOptions[0]?.value;
  }
  private hasMultimediaCabin(): boolean {
    return this.event['parametros']['cabin_video'] ? true : false;
  }
  private hasMultimediaRoad(): boolean {
    return this.event['parametros']['road_video'] ? true : false;
  }

  // permission
  private hasGetVideoDetailPermission(): Promise<boolean> {
    return this.permissionService.hasPermission(
      'events_popupMediaOptions_VideoOnDemand_withDetail'
    );
  }
  private hasVideoRecordPermission(): Promise<boolean> {
    return this.permissionService.hasPermission(
      'events_popupMediaOptions_VideoRecord'
    );
  }
  private hasVideoOnDemand(): Promise<boolean> {
    return this.permissionService.hasPermission(
      'events_popupMediaOptions_VideoOnDemand'
    );
  }

  async ngAfterViewInit(): Promise<void> {
    this.permissionGetVideoDetail = await this.hasGetVideoDetailPermission();

    let permissionRecord = await this.hasVideoRecordPermission();
    // console.log('Saint:', permissionRecord);

    let permissionDemand = await this.hasVideoOnDemand();

    if (permissionRecord) {
      this.addMenuItem('Grabar video', 'pi pi-fw pi-video', () =>
        this.getRecordDialog()
      );
    }
    if (permissionDemand) {
      this.addMenuItem(
        'Obtener video',
        'pi pi-fw pi-sliders-h',
        async () => await this.getVideoDialog()
      );
    }
  }

  private addMenuItem(label: string, icon: string, command: () => void): void {
    this.menuMultimedia.push({ label, icon, command });
  }

  shouldShowVideo(item: any): boolean {
    return !this.error && !this.loading && item.type === 'video';
  }

  ngOnDestroy() {
    console.log("multi : destoy slider multimedia", this.event.uuid_event)
    if (this.multimediaSubscription) {
      this.multimediaSubscription.unsubscribe();
    }
    this.multimediaService.cleanupVideoRequests();
    this.destroy$.next();
    this.destroy$.complete();

    // Clean up DOM references
    this.sliderContent = null;

    if (this.mouseTimer) {
      clearTimeout(this.mouseTimer);
    }
    this.destroy$.next();
    this.destroy$.complete();


  }

  private handleMultimediaEvent(): void {

    this.checkCipiaMultimedia(
      this.event.parametros,
      this.event.imei,
      this.event.uuid_event
    );
    //console.log("MULTIMEDIAS RENDERED======= ",this.multimediaService.multimediaCipiaItems[this.event.parametros.eventId]);
    if (this.showMultimediaFirst) {
      this.loadMedia();
    }
  }

  ngOnInit(): void {
    console.log("slider multimedia init ", this.event)
    this.generateDays();

    this.setupMultimediaHandling();

    const eventDateTimeUTC = this.event.parametros.eventDateTime;

    const minRangeString = this.momentService.toLocalWithOptions(
      eventDateTimeUTC,
      -2,
      'minutes'
    );
    this.min_range = minRangeString.valueOf() as number;

    const maxRangeString = this.momentService.toLocalWithOptions(
      eventDateTimeUTC,
      +2,
      'minutes'
    );
    this.max_range = maxRangeString.valueOf() as number;

    const rangeStartString = this.momentService.toLocalWithOptions(
      eventDateTimeUTC,
      -15,
      'seconds'
    );
    const rangeEndString = this.momentService.toLocalWithOptions(
      eventDateTimeUTC,
      15,
      'seconds'
    );

    this.updateSelectedTime(rangeStartString.valueOf()); // para obtener video

    this.rangeValues = [
      rangeStartString.valueOf() as number,
      rangeEndString.valueOf() as number,
    ];
    this.sliderContent = document.querySelector(
      '.slider-content'
    )! as HTMLElement;

    this.updateVideoRange();
  }

  isValidTime(time: any): boolean {
    return time instanceof Date && !isNaN(time.getTime());
  }

  onTimeChange(value: any) {
    console.log(value, "slider multiview change time")
    if (!this.isValidTime(value)) {
      console.error('Hora inválida');
      // Ejemplo: limpiar el valor o mostrar notificación
      this.selectedTime = new Date();
    }
  }

  private setupMultimediaHandling(): void {
    this.showMultimedias = !!this.showMultimediaFirst;

    if (this.multimediaService.store.isLoadedMultimediaCipia) {
      this.handleMultimediaEvent();
    } else {
      this.multimediaSubscription = this.multimediaService.store.completedMultimediaCipia
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.handleMultimediaEvent());
    }
  }

  private setupMapAsideSubscription(): void {
    this.mapAsideService.isMaximized$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isMaximized) => {
        this.isMaximized = isMaximized;
        this.cdRef.markForCheck(); // More efficient than detectChanges()
      });
  }

  private setupDateTimeRanges(): void {
    if (!this.event?.parametros?.eventDateTime) {
      console.warn('Missing eventDateTime parameter');
      return;
    }

    const eventDateTimeUTC = this.event.parametros.eventDateTime;

    // Set time ranges
    this.min_range = this.getMomentValue(eventDateTimeUTC, -2, 'minutes');
    this.max_range = this.getMomentValue(eventDateTimeUTC, 2, 'minutes');

    const rangeStart = this.getMomentValue(eventDateTimeUTC, -15, 'seconds');
    const rangeEnd = this.getMomentValue(eventDateTimeUTC, 15, 'seconds');

    this.updateSelectedTime(rangeStart);
    this.rangeValues = [rangeStart, rangeEnd];
  }

  private getMomentValue(baseDate: any, amount: number, unit: any): number {
    const result = this.momentService.toLocalWithOptions(baseDate, amount, unit).valueOf();
    return Number(result); // Explicitly convert to number
  }

  private cacheSliderElement(): void {
    try {
      this.sliderContent = document.querySelector('.slider-content');
      if (!this.sliderContent) {
        console.warn('Slider content element not found');
      }
    } catch (error) {
      console.error('Error accessing DOM element:', error);
    }
  }

  checkCipiaMultimedia(params: any, imei: string, uuid: string) {

    if (!this.multimediaService.hasUuid_eventInMultimediaItems(uuid)) {
      this.multimediaService.initializeNewMultimediaCipiaItem(uuid);
    }
    this.multimediaCipiaItems = this.getMultimediaCipiaItems(this.event.uuid_event)

    if (
      params['gps'] === 'cipia' &&
      (params['has_video'] === '1' || params['has_image'] === '1')
    ) {
      this.hasMultimedia = true;
      // function logic
      const addMultimediaItem = (
        mediaType: TypeCipiaMultimedia,
        source: SourceCipiaMultimedia,
        description: string,
        interval: any
      ) => {
        this.addMultimediaCipiaItem(
          params,
          imei,
          uuid,
          mediaType,
          source,
          description,
          interval
        );
      };
      const getDescription = (
        eventDateTime: string,
        isImage: boolean
      ): string => {
        if (isImage) {
          return `Hora: ${this.momentService.toLocal(eventDateTime, true)}`;
        } else {
          const startTime = this.momentService.toLocalWithOptions(
            eventDateTime,
            -7,
            'seconds',
            true
          );
          const endTime = this.momentService.toLocalWithOptions(
            eventDateTime,
            +3,
            'seconds',
            true
          );
          return `Desde: ${startTime} hasta: ${endTime}`;
        }
      };
      const getInterval = (
        eventDateTime: string,
        startOffset: number,
        endOffset: number
      ): any => {
        return this.multimediaService.getInterval(
          eventDateTime,
          startOffset,
          endOffset,
          'event'
        );
      };

      const hasMultimediaNative = (type: TypeCipiaMultimedia): boolean => {
        return this.multimediaCipiaItems.some(multi => multi.native === true && multi.type === type);
      };


      if (params['has_image'] === '1') {

        if (!hasMultimediaNative("image")) {
          const description = getDescription(params['eventDateTime'], true);

          if (params['cabin_image'] === '1') {
            const interval = getInterval(params['eventDateTime'], 0, 0);
            addMultimediaItem('image', 'CABIN', description, interval);
          }

          if (params['road_image'] === '1') {
            const interval = getInterval(params['eventDateTime'], -7, 3);
            addMultimediaItem('image', 'ROAD', description, interval);
          }
        }

      }

      if (params['has_video'] === '1' && this.event.evento != "checklist-daily") {
        if (!hasMultimediaNative("video")) {
          const description = getDescription(params['eventDateTime'], false);
          const interval = getInterval(params['eventDateTime'], -7, 3);
          if (params['cabin_video'] === '1') {
            addMultimediaItem('video', 'CABIN', description, interval);
          }

          if (params['road_video'] === '1') {
            addMultimediaItem('video', 'ROAD', description, interval);
          }
        }
      }
    } else if (params['gps'] == 'cipia' && this.eventService.videoDemandInEvents[this.event.evento]) {
      this.getMultimediaByRangeSpecificPublic(
        this.event.fecha_tracker, 10
      )
    }
  }

  addMultimediaCipiaItem(
    params: any,
    imei: string,
    uuid: string,
    type: TypeCipiaMultimedia,
    source: SourceCipiaMultimedia,
    description: string,
    interval: IntervalTime
  ) {
    this.multimediaService.addMultimediaCipiaItem(
      params['eventId'],
      {
        type: type,
        params: {
          imei: imei,
          eventId: params['eventId'],
          type: type,
          source: source,
        },
        description,
        url: '',
        objectUrl: '',
        blobId: '',
        interval,
        loading: false,
        completed: false,
        native: true
      },
      uuid,
    );
  }

  prev() {
    if (!this.loading) {
      this.activeIndex++;
      //console.log(this.multimediaWrapper.nativeElement);
      this.loadMedia();
    }
  }

  next() {
    if (!this.loading) {
      this.activeIndex--;
      //console.log(this.multimediaWrapper.nativeElement);
      this.loadMedia();
    }
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (
      event.target instanceof HTMLInputElement ||
      event.target instanceof HTMLTextAreaElement
    )
      return;

    switch (event.key.toLowerCase()) {
      case 'u':
        event.preventDefault();
        this.next();
        break;
      case 'o':
        event.preventDefault();
        this.prev();
        break;
    }
  }

  public getMultimediaDemanRetry() {
    this.getMultimediaByRangeSpecificPublic(
      this.event.fecha_tracker, 10
    )
  }

  async loadMedia(): Promise<void> {
    this.error = false;
    this.loading = true;
    this.multimediaService
      .loadMediaFromMultimediaItem(
        this.activeIndex - 1,
        this.event.parametros.eventId,
        this.event.uuid_event,
        undefined,
      )
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.multimediaCipiaItems = this.getMultimediaCipiaItems(this.event.uuid_event)
        this.loading = false;
      });
  }

  changeShowMultimedia() {
    this.showMultimedias = !this.showMultimedias;
    if (this.showMultimedias) {
      this.loadMedia();
    }
  }

  toggleMaximize() {
    this.isMaximized = !this.isMaximized;
    this.mapAsideService.setIsMaximized(this.isMaximized);
    // this.updateMaximizeState();
  }

  updateMaximizeState() {
    if (this.sliderContent) {
      if (this.isMaximized) {
        // Maximizar
        this.sliderContent.classList.add('maximized');
      } else {
        // Minimizar
        this.sliderContent.classList.remove('maximized');
      }
    }
  }

  async getVideoDialog() {
    this.showGetVideoDialog = !this.showGetVideoDialog;
    await this.updateSliderBackground();
    this.cdRef.detectChanges();
  }

  async getRecordDialog() {
    this.showRecordVideoDialog = !this.showRecordVideoDialog;
  }

  private getTimestampFromUtcOrCurrent(date: string): number {
    const timestamp = new Date(date).getTime();
    return isNaN(timestamp) ? Date.now() : timestamp;
  }

  public loadingDemand = false;
  public loadingDemandError = false;

  public saveVideoSpecialEvent = false;

  public getMultimediaByRangeSpecificPublic(time: string, duration: number) {
    if (!this.multimediaService.hasItemsForUuid(this.event.uuid_event)) {
      const params = this.generateMultimediaParams(
        time,
        duration,
        this.mediaStoreCipiaValue
      );
      console.log("cargar video rango espcifico,", params)
      this.loadingDemand = true;
      this.loadingDemandError = false;

      if (!this.multimediaService.includeDemandInPeticionesDemand(params)) {
        this.multimediaService.addNewVideoDemand(params)
        this.multimediaService.getVideoOnDemand(
          "demand",
          params,
          this.event,
          this.rowSelected,
          true
        ).subscribe({
          next: (response) => {
            // Aquí capturas el resultado exitoso
            console.log('Respuesta exitosa:', response, this.event, params);
            this.loadingDemand = false;
            this.multimediaService.removeVideoDemand(params)
            this.showMultimedias = true
            this.saveVideoSpecialEvent = true;
            this.loadMedia()
          },
          error: (error) => {
            // Aquí capturas el error
            this.loadingDemand = false;
            this.loadingDemandError = true;
            this.multimediaService.removeVideoDemand(params)
            console.error('Ocurrió un error:', error);
          }
        });
      }
    }
  }

  public getMultimediaByRangeSpecific() {
    console.log("multimedia Service: get Video specific range")
    if (!this.isTimeOutOfRange) {
      const timeUTC = this.getFormattedDateInLocal();
      console.log(timeUTC, "get multimedia range utc")
      const params = this.generateMultimediaParams(
        timeUTC,
        this.duration,
        this.mediaStoreCipiaValue
      );
      this.getVideoMultimedia(params, 'demand');
    }
  }
  getMultimediaByRange(rangeValues: number[]) {
    const fromUtc = moment(new Date(rangeValues[0]), 'YYYY/MM/DD HH:mm:ss')
      .utcOffset(0, true)
      .format('YYYY/MM/DD HH:mm:ss');
    console.log(fromUtc, "get multimedia range utc")

    const seconds = (rangeValues[1] - rangeValues[0]) / 1000;

    const params = this.generateMultimediaParams(
      fromUtc,
      seconds,
      this.mediaStoreCipiaValue
    );
    this.getVideoMultimedia(params, 'demand');
  }

  private generateMultimediaParams(
    fromUtc: string,
    seconds: number,
    source: SourceCipiaMultimedia
  ): CipiaMultimediaParam {
    return {
      imei: this.event.imei,
      type: 'video',
      seconds: seconds,
      from: fromUtc,
      timestamp: this.getTimestampFromUtcOrCurrent(''),
      source,
      eventId: this.event.parametros.eventId,
    };
  }

  private async getVideoMultimedia(
    params: CipiaMultimediaParam,
    option: VideoOnDemandTime
  ) {
    await this.multimediaService.getVideoOnDemand(
      option,
      params,
      this.event,
      this.rowSelected
    ).subscribe();
    //this.loadMedia();
    this.showGetVideoDialog = false;
  }

  public getMultimediaRecording(recordTime: number) {
    const timeUtc = moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
      .add(1, 'second')
      .utcOffset(0, true)
      .format('YYYY-MM-DD HH:mm:ss');
    const params = this.generateMultimediaParams(
      timeUtc,
      recordTime,
      this.mediaCipiaValue
    );
    this.getVideoMultimedia(params, 'now');
    this.showRecordVideoDialog = false;
  }

  async updateSliderBackground(): Promise<void> {
    let auxGradientColor = '';
    let intervals = [];
    for (const multimedia of this.getMultimediaItems()) {
      if (multimedia.type == 'video') {
        intervals.push(multimedia.interval);
        //intervals.push(new Date(multimedia.interval!.start).getTime());
        //intervals.push(new Date(multimedia.interval!.end!).getTime());
      }
    }
    //console.log("this.min_range: ", this.min_range);
    //console.log("this.max_range: ", this.max_range);
    //console.log("intervals: ",intervals);
    const percents = [];
    for (const interval of intervals) {
      percents.push({
        start: (
          ((new Date(interval!.start).getTime() - this.min_range) /
            (this.max_range - this.min_range)) *
          100
        ).toFixed(1),
        end: (
          ((new Date(interval!.end!).getTime() - this.min_range) /
            (this.max_range - this.min_range)) *
          100
        ).toFixed(1),
        color:
          interval!.type! == 'event'
            ? 'var(--gl-vivid-red-alpha)'
            : interval!.type! == 'retrieve'
              ? 'var(--gl-enable-green-alfa)'
              : 'var(--gl-blue-electric-alpha)',
        type: interval!.type,
      });
    }

    //console.log("percents: ",percents);

    percents.sort((a, b) => {
      // Primero, ordenar por 'tipo' en el orden deseado
      const types = ['event', 'recording', 'retrieve'];
      const indexA = types.indexOf(a.type!);
      const indexB = types.indexOf(b.type!);

      if (indexA < indexB) return -1;
      if (indexA > indexB) return 1;

      if (a.start < b.start) return -1;
      if (a.start > b.start) return 1;

      return 0;
    });
    for (let i = 0; i < percents.length; i++) {
      auxGradientColor +=
        `linear-gradient(to right, transparent 0% ${percents[i].start}%, ${percents[i].color + ' ' + percents[i].start
        }% ${percents[i].end}%, transparent ${percents[i].end}% 100% )` +
        (i + 1 < percents.length ? ', ' : '');
      // const percent = percents[i];
      // if(isStartInterval){
      //   auxGradientColor += 'linear-gradient(to right, #f3f6f4 0%, #f3f6f4 '+ percent.start + '%, transparent 0%)';
      //   isStartInterval = false;
      // }
      // const transparent = (i+1 < percents.length) ? (parseFloat(percents[i+1].start) - parseFloat(percent.end)) : 0;
      // const isIncluded = (i+1 < percents.length) ? (parseFloat(percents[i+1].end) <= parseFloat(percent.end)) : false;
      // if(transparent < 0){
      //   // si el subsiguiente inicio es menor que el final de este intervalo, significa que hay un traslap
      //   if(isIncluded){
      //     // Ese traslape podria abarcar todo el intervalo subsiguiente, por tanto se debe tomar precaicion
      //     auxGradientColor += `,linear-gradient(to right, ${percent.color +' '+ percent.start}%, ${percent.color +' '+ percents[i+1].start}%, transparent 0% )`;
      //     auxGradientColor += `,linear-gradient(to right, ${percent.color +' '+ percents[i+1].end}%, ${percent.color +' '+ percent.end}%, transparent 0% )`;
      //   }else{
      //     auxGradientColor += `,linear-gradient(to right, ${percent.color +' '+ percent.start}%, ${percent.color +' '+ percents[i+1].start}%, transparent ${parseFloat(percents[i+1].start)+ Math.abs(transparent)}% )`;
      //   }
      // }else{
      //   //si no hay traslape, solo pongo el color y añado un gris adicionalmente
      //   auxGradientColor += `,linear-gradient(to right, ${percent.color +' '+ percent.start}%, ${percent.color +' '+ percent.end}%, transparent 0% )`;
      //   //añado un gris, si no hay un subiguiente elemento, coloreo hasta el 100% sino solo hasta el inicio del subsiguiente.
      //   auxGradientColor += `,linear-gradient(to right, #f3f6f4 ${percent.end}%, #f3f6f4 ${i+1 < percents.length? percents[i+1].start : '100'}%, transparent 0%)`;
      // }
    }
    this.gradientColor = auxGradientColor;
    this.cdRef.detectChanges();
    Promise.resolve();
  }

  addMinMaxTime(seconds: number) {
    if (seconds < 0) {
      this.min_range += seconds * 1000;
    } else {
      this.max_range += seconds * 1000; // ME QUEDE ACA
    }
    this.updateSliderBackground();
    this.sliderComponent.writeValue(this.rangeValues);
  }

  isLoadedVideo = false;

  onLoadVideo() {
    this.isLoadedVideo = true;
  }
}
